import React from "react";
import { withNavBars } from "../../HOCs";
import CustomerGroupMaster from "./customerGroupMaster";

class CustomerGroupMasterParent extends React.Component {
  render() {
    return <CustomerGroupMaster {...this.props} />;
  }
}

const props = {
  boxShadow: false
}

export default withNavBars(CustomerGroupMasterParent, props);
